var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.hide)?_c('v-img',{staticClass:"control--height",attrs:{"width":"15vh","src":require("@/assets/logo beta white.svg")}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }